import styled from 'styled-components';
import { Button } from 'components';
import { Modal, Button as Btn } from 'react-bootstrap';

export const ProgramsContainer = styled.div`
  float: left;
  opacity: ${(props) => (props.open ? '1' : '0')};
  transition: all 0.5s;

  > div {
    position: ${(props) => (props.open ? 'unset' : 'absolute')};
  }
  
  &.programsContainer__empty {
    display: flex;
    height: 100%;
  }
`;

export const DetailContainer = styled.div`
  opacity: ${(props) => (props.open ? '1' : '0')};
  margin-left: ${(props) => (props.open ? '0' : '100%')};
  width: 100%;
  transition: all 0.5s;
`;

export const CloseButton = styled(Button)`
  margin: 0;
`;

export const Body = styled(Modal.Body)`
  padding: 0;
`;

export const ModalFooter = styled(Modal.Footer)`
  border: 0;
  justify-content: center;

  > button:last-child {
    color: gray;
  }
`;

export const Header = styled(Modal.Header)`
  border: 0;

  > .close {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  a {
    color: ${({ theme }) => theme.palette.primary[2]};
  }
`;

export const ModalContainer = styled(Modal)`
  font-size: ${({ theme }) => theme.sizes.normal};
  color: ${({ theme }) => theme.palette.grayscale[1]};

  .modal-content {
    border-radius: 0.8rem;
    padding: 1rem 2rem;
    border: 0;
  }

  > div {
    max-width: 700px;
  }

  .container {
    height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    max-width: 100%;

    > div {
      width: 100%;
      > div {
        width: 100%;
      }
    }
  }
`;

export const Spinner = styled.div`
  text-align: center;
`;

export const ShowMore = styled.div`
  text-align: center;

  > button {
    color: ${({ theme }) => theme.palette.primary[0]};
  }
`;

export const PageButton = styled(Btn)`
  color: ${({ theme }) => theme.palette.primary[0]};
  font-size: 0.9rem;
  padding: 0.3rem;
`;
